import { createAsyncThunk } from "@reduxjs/toolkit";
import { mapSiteVisitLists, mapInspectionLists, mapInspectionTimeLists } from "../Types/SiteVisit/SiteVisitTypes";
import { getSiteVisitByFolderId, getInspectionList, getInspectionTimeList } from "../../Api/SiteVisit/SiteVisitApiServices";

// Get all site vist list
export const getAllSiteVisitList = createAsyncThunk('getAllSiteVisitList', async (folder_id: number, { rejectWithValue }) => {
    try {
        // api
        const response = await getSiteVisitByFolderId(folder_id);
        if (response.status) {
            return mapSiteVisitLists(response.body);
        } else {
            // If the API returns a failure status, return the error message
            return rejectWithValue(response.error);
        }
    } catch (error: any) {
        // Handle the case where the API call itself throws an error
        return rejectWithValue('Failed to fetch all projet details');
    }
});

// Get all inspections list
export const getAllInspectionsList = createAsyncThunk('getAllInspectionsList', async (_, { rejectWithValue }) => {
    try {
        // api
        const response = await getInspectionList();
        if (response.status) {
            return mapInspectionLists(response.body);
        } else {
            // If the API returns a failure status, return the error message
            return rejectWithValue(response.error);
        }
    } catch (error: any) {
        // Handle the case where the API call itself throws an error
        return rejectWithValue('Failed to fetch all projet details');
    }
});

// Get all inspection time list
export const getAllInspectionTimeList = createAsyncThunk('getAllInspectionTimeList', async (_, { rejectWithValue }) => {
    try {
        // api
        const response = await getInspectionTimeList();
        if (response.status) {
            return mapInspectionTimeLists(response.body);
        } else {
            // If the API returns a failure status, return the error message
            return rejectWithValue(response.error);
        }
    } catch (error: any) {
        // Handle the case where the API call itself throws an error
        return rejectWithValue('Failed to fetch all projet details');
    }
});